import { max, min_value } from '@vee-validate/rules';

export default {
    data() {
        return {
            serialNumbersConfiguration: {
                type: 'SerialNumbers',
                label: 'Serialized Items',
                sampleNotes: ['"Include a Barcode, Serial Number, and Location for each serialized item to import."',
                    '"The product must already exist, and the serial number must be unique and not currently exist."',
                    '"Any errors on import can be reviewed in the Data Exchange Log."'
                ],
                fields: [
                    {
                        key: 'Barcode',
                        label: 'Barcode',
                        hasErrorCalculator: value => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            return max(value, { length: 128 }) !== true;
                        },
                        rules: {
                            required: true,
                            max: { length: 128 }
                        },
                        samples: ['"2235467890161"','"1135467890171"']
                    },
                    {
                        key: 'SerialNumber',
                        label: 'Serial Number',
                        hasErrorCalculator: value => {
                            if (this.isEmpty(value)) {
                                return true;
                            }
                            return max(value, { length: 25 }) !== true;
                        },
                        rules: 'required|max:25',
                        samples: ['"SU123-5678-1234-6789"', '"6549-6544-6as5-asdd"']
                    },
                    {
                        key: 'Location',
                        label: 'Location',
                        hasErrorCalculator: value => {
                            return (value == '' ||
                                value == undefined ||
                                min_value(value, { min: 0 }) !== true);
                        },
                        rules: 'required|min_value:0',
                        samples: ['"North Campus"', '"City Campus"'],
                        dataType: 'locations'
                    },                     
                ]
            }
        };
    }
};
